import { useLocation } from '@reach/router';
import { getSearchParameterByName } from './helpers';

export const useSearchParameter = (name: string) => {
  const location = useLocation();
  const params = getSearchParameterByName<string>(name, location);

  return params;
};
